// import React, { useState, useEffect } from "react";
// import {
//   Button,
//   Table,
//   TableBody,
//   TableCell,
//   TableHead,
//   TableRow,
//   Modal,
//   Box,
// } from "@mui/material";
// import useHttp from "../../Hooks/use-http";
// import {
//   useHistory,
//   useLocation,
// } from "react-router-dom/cjs/react-router-dom.min";
// import { toast } from "react-toastify";

// const VehicleVerification = () => {
//   const [documents, setDocuments] = useState([]);
//   const [viewImage, setViewImage] = useState(null); // For modal image preview
//   const [loading, setLoading] = useState(false);
//   const [emailID, setEmailID] = useState(null);
//   const { sendRequest } = useHttp();
//   const history = useHistory();

//   const location = useLocation();
//   useEffect(() => {
//     if (location.state && location.state.data) {
//       setEmailID(location.state.data.regNumber);
//     }
//   }, [location.state]);

//   React.useEffect(() => {
//     sendRequest(
//       {
//         url: "/document",
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: {
//           emailID: localStorage.getItem("user"),
//           data: {
//             category: "vehicle",
//             numberPlate: emailID,
//           },
//         },
//       },
//       documentDetails
//     );
//   }, [emailID]);

//   const documentDetails = (data) => {
//     setDocuments(data.document);
//   };

//   const handleVerify = (docId, index) => {
//     setDocuments((prevDocs) =>
//       prevDocs.map((doc, idx) =>
//         // doc.documentID === docId
//         idx === index
//           ? {
//               ...doc,
//               isVerified: 1,
//               approvedBy: localStorage.getItem("user"),
//               approvedOn: new Date(
//                 new Date().getTime() + 5 * 60 * 60 * 1000 + 30 * 60 * 1000
//               ).toISOString(),
//               isMarkedVerified: true,
//             }
//           : doc
//       )
//     );
//   };

//   const handleSubmit = async () => {
//     setLoading(true);

//     // Check if all documents with isVerified !== null && !== 1 are verified
//     const allManuallyVerified = documents.every((doc) =>
//       doc.isVerified !== null && doc.isVerified !== 1
//         ? doc.isMarkedVerified
//         : true
//     );

//     if (!allManuallyVerified) {
//       toast.error("Please verify all required documents before submitting.");
//       setLoading(false);
//       return;
//     }

//     // If all required documents are verified, update remaining null/1 ones to 1
//     const updatedDocuments = documents.map((doc) => ({
//       ...doc,
//       isVerified:
//         doc.isVerified === null || doc.isVerified === 1 ? 1 : doc.isVerified,
//     }));

//     try {
//       const response = await sendRequest({
//         url: "/addupdatedocument",
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: {
//           emailID: localStorage.getItem("user"),
//           data: updatedDocuments, // Send the modified document list
//         },
//       });

//       if (response.status === 200 || response.status === 201) {
//         toast.success(response.message);
//         history.push("/vehicles");
//       }
//     } catch (error) {
//       toast.error("Failed to update documents.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div style={{ padding: "20px" }}>
//       <h2>Verification Documents</h2>
//       <Table>
//         <TableHead>
//           <TableRow>
//             <TableCell>Document ID</TableCell>
//             <TableCell>Document Number</TableCell>
//             <TableCell>Image</TableCell>
//             <TableCell>Status</TableCell>
//             <TableCell>Action</TableCell>
//           </TableRow>
//         </TableHead>
//         <TableBody>
//           {documents?.length == 0 ? (
//             <>
//               <h2>No Documents</h2>
//             </>
//           ) : (
//             <>
//               {documents?.map((doc, index) => (
//                 <TableRow key={doc.documentID}>
//                   <TableCell>{doc.documentID}</TableCell>
//                   <TableCell>{doc.documentNumber}</TableCell>

//                   <TableCell>
//                     <img
//                       src={doc?.documentURL}
//                       alt="Document"
//                       style={{ width: "100px", cursor: "pointer" }}
//                       onClick={() => setViewImage(doc?.documentURL)}
//                     />
//                   </TableCell>
//                   <TableCell>
//                     {doc?.isVerified ? "Verified" : "Pending"}
//                   </TableCell>
//                   <TableCell>
//                     <Button
//                       variant="contained"
//                       color="primary"
//                       disabled={
//                         doc?.isVerified == null || doc?.isVerified === 1
//                         // doc?.isVerified === 1
//                       }
//                       onClick={() => handleVerify(doc.documentID, index)}
//                     >
//                       Verify
//                     </Button>
//                   </TableCell>
//                 </TableRow>
//               ))}
//             </>
//           )}
//         </TableBody>
//       </Table>
//       <Button
//         variant="contained"
//         color="success"
//         onClick={handleSubmit}
//         style={{ marginTop: "20px" }}
//         disabled={loading}
//       >
//         Submit
//       </Button>

//       {/* Modal for viewing image */}
//       <Modal open={!!viewImage} onClose={() => setViewImage(null)}>
//         <Box
//           style={{
//             position: "absolute",
//             top: "50%",
//             left: "50%",
//             transform: "translate(-50%, -50%)",
//             backgroundColor: "white",
//             padding: "20px",
//             boxShadow: 24,
//             borderRadius: "8px",
//             width: "40%",
//             position: "relative", // Keep the position relative to ensure correct placement of the button
//           }}
//         >
//           {/* <div style={{ position: "relative" }}> */}
//           <img
//             src={viewImage}
//             alt="Document Preview"
//             style={{ width: "50%", height: "50%" }}
//           />

//           <Button
//             onClick={() => setViewImage(null)}
//             style={{
//               // position: "absolute",
//               // top: "5px", // Position at the top right of the image
//               // right: "5px",
//               color: "red",
//               background: "none",
//               border: "none",
//               fontSize: "16px",
//               cursor: "pointer",
//             }}
//           >
//             X
//           </Button>

//           {/* </div> */}
//         </Box>
//       </Modal>
//     </div>
//   );
// };

// export default VehicleVerification;

import React, { useState, useEffect } from "react";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  IconButton,
} from "@mui/material";
import useHttp from "../../Hooks/use-http";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";
import { FormatDateTime } from "../CommonComponent/DateFormat";
import { ReactComponent as AddSign } from "../../Assets/Plus_sign.svg";
import UpdateVerificationDocumentsForVehicle from "./UpdateVerificationDocumentsForVehicle";

const VehicleVerification = () => {
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(false);
  const [vehicleNumber, setVehicleNumber] = useState(null);
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false);
  const [selectedDocID, setSelectedDocID] = useState(null);
  const [isRefresh, setIsRefresh] = useState(false);

  const { sendRequest } = useHttp();
  const history = useHistory();

  const location = useLocation();
  useEffect(() => {
    if (location.state && location.state.data) {
      setVehicleNumber(location.state.data);
    }
  }, [location.state]);

  // ------------------------------------merging

  const [mergedDocuments, setMergedDocuments] = useState([]);

  useEffect(() => {
    // Only call API when vehicleNumber and regNumber are available
    if (vehicleNumber?.regNumber) {
      sendRequest(
        {
          url: "/documentMergedData",
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: {
            emailID: localStorage.getItem("user"),
            data: {
              category: "Vehicle",
              numberPlate: vehicleNumber.regNumber,
            },
          },
        },
        documentDetails
      );
    }
  }, [vehicleNumber, isRefresh]);

  // -----------------------------------------merging

  const documentDetails = (data) => {
    setMergedDocuments(data.mergedData);
  };

  const handleVerify = async (docId, index) => {
    try {
      const approvedBy = localStorage.getItem("user");
      const approvedOn = new Date(
        new Date().getTime() + 5 * 60 * 60 * 1000 + 30 * 60 * 1000
      ).toISOString();

      // Get the current document from state
      const currentDoc = mergedDocuments[index];

      // Prepare the update data according to your backend expectations
      const updateData = {
        id: currentDoc.id, // This is CRUCIAL - must include the document's database ID
        documentID: currentDoc.documentID,
        documentNumber: currentDoc.documentNumber,
        url: currentDoc.url,
        isVerified: 1,
        approvedBy: approvedBy,
        approvedOn: approvedOn,
        numberPlate: vehicleNumber?.regNumber,
        category: currentDoc.category,
        // Include any other required fields that might be needed for validation
        ...(currentDoc.expiryDate && { expiryDate: currentDoc.expiryDate }),
      };

      // Update UI immediately
      const updatedDocuments = [...mergedDocuments];
      updatedDocuments[index] = {
        ...currentDoc,
        isVerified: 1,
        approvedBy,
        approvedOn,
        updatedAt: approvedOn,
      };
      setMergedDocuments(updatedDocuments);

      // Send to backend
      const response = await sendRequest({
        url: "/addupdatedocument",
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: {
          emailID: approvedBy,
          data: [updateData], // Your backend expects an array
        },
      });

      if (response.status === 200 || response.status === 201) {
        toast.success("Document verified successfully!");
        setIsRefresh(!isRefresh);
      } else {
        throw new Error(response.message || "Failed to verify document");
      }
    } catch (error) {
      toast.error(error.message);
      // Revert UI if API call fails
      const revertedDocuments = [...mergedDocuments];
      setMergedDocuments(revertedDocuments);
    }
  };

  const handleUpdateSuccess = () => {
    setIsRefresh((prev) => !prev); // trigger useEffect to re-call /documentMergedData
  };
  return (
    <div style={{ padding: "20px" }}>
      <h4>Verification Documents</h4>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Document ID</TableCell>
            <TableCell>Document Number</TableCell>
            <TableCell>Document Name</TableCell>

            <TableCell>Image</TableCell>
            <TableCell>Status</TableCell>
            <TableCell>UpdateAt</TableCell>

            <TableCell>Action</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {mergedDocuments?.length === 0 ? (
            <TableRow>
              <TableCell colSpan={5}>
                <h2>No Documents</h2>
              </TableCell>
            </TableRow>
          ) : (
            mergedDocuments?.map((doc, index) => {
              // Check if document has image/URL
              const hasImage = doc.url && doc.url.trim() !== "";
              // Check if document has document number
              const hasDocumentNumber = doc.documentNumber && doc.documentNumber.trim() !== "";
              // Verify button should only show if document has image OR document number
              // AND document is not verified
              const hasImageOrNumber = hasImage || hasDocumentNumber;
              // isVerified can be false (boolean), 0 (number), null, or undefined - all mean not verified
              // Only 1 (number) or true (boolean) means verified
              const isNotVerified = doc.isVerified === false || doc.isVerified === 0 || doc.isVerified === null || doc.isVerified === undefined;
              const canVerify = hasImageOrNumber && isNotVerified;
              // Document is incomplete only if it has no URL at all
              const isIncomplete = !doc.url || doc.url.trim() === "";

              return (
                <TableRow key={doc.documentID}>
                  <TableCell>{doc.documentID}</TableCell>
                  <TableCell>{doc.documentNumber || "-"}</TableCell>
                  <TableCell>{doc.documentName}</TableCell>

                  {/* <TableCell>
                    {doc.url ? (
                      <img
                        src={doc.url}
                        alt="Document"
                        style={{ width: "100px", cursor: "pointer" }}
                        onClick={() => setViewImage(doc.url)}
                      />
                    ) : (
                      "No Image"
                    )}
                  </TableCell> */}

                  <TableCell>
                    {doc.url ? (
                      // For all file types (images and PDFs), show "View" text that opens in new window
                      <div
                        style={{ cursor: "pointer", color: "blue" }}
                        onClick={() => window.open(doc.url, "_blank")}
                      >
                        View
                      </div>
                    ) : (
                      "No File"
                    )}
                  </TableCell>

                  <TableCell>
                    {doc?.isVerified ? "Verified" : "Pending"}
                  </TableCell>
                  <TableCell>{FormatDateTime(doc.updatedAt)}</TableCell>

                  <TableCell>
                    {/* Show verify button if document is uploaded and not verified */}
                    {canVerify ? (
                      <div style={{ display: "flex", gap: "5px" }}>
                        <Button
                          variant="contained"
                          color="primary"
                          size="small"
                          disabled={false}
                          onClick={() => handleVerify(doc.documentID, index)}
                          style={{ marginRight: "8px" }}
                        >
                          Verify
                        </Button>

                        <IconButton
                          onClick={() => {
                            setSelectedDocID(doc.documentID);
                            setIsUpdateModalOpen(true);
                          }}
                        >
                          {/* <AddIcon /> */}
                          <AddSign />
                        </IconButton>
                      </div>
                    ) : (
                      // If document is incomplete, only show update button
                      // If document is verified, only show update button
                      <IconButton
                        onClick={() => {
                          setSelectedDocID(doc.documentID);
                          setIsUpdateModalOpen(true);
                        }}
                      >
                        {/* <AddIcon /> */}
                        <AddSign />
                      </IconButton>
                    )}
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>

      {isUpdateModalOpen && (
        <UpdateVerificationDocumentsForVehicle
          open={isUpdateModalOpen}
          onClose={() => setIsUpdateModalOpen(false)}
          number={vehicleNumber}
          documentss={documents}
          documentID={selectedDocID}
          onSuccess={handleUpdateSuccess}
        />
      )}
    </div>
  );
};

export default VehicleVerification;
